import CmsModalBlock from './CmsModalBlock';

export default CmsModalBlock;
